import { render, staticRenderFns } from "./fengrenMb.vue?vue&type=template&id=5f1a5c90&scoped=true&"
import script from "./fengrenMb.vue?vue&type=script&lang=js&"
export * from "./fengrenMb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1a5c90",
  null
  
)

export default component.exports